import VDatePicker from './VDatePicker'

/* istanbul ignore next */
VDatePicker.install = function install (Vue) {
  Vue.component(VDatePicker.name, VDatePicker)
}

export default VDatePicker



// WEBPACK FOOTER //
// ./src/components/VDatePicker/index.js